var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _line, _line2, _line3, _line4, _line5, _line6, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeBranchRevision48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad_2",
    "data-name": "Dark Blue Grad 2",
    x1: 28.5,
    y1: 3.5,
    x2: 41.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74b3c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#6badc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#539db4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#2d839d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177490"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient",
    "data-name": "paper gradient",
    x1: 6.5,
    y1: 3.501,
    x2: 19.5,
    y2: 16.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient-2",
    x1: 28.5,
    y1: 17.5,
    x2: 41.5,
    y2: 30.5,
    xlinkHref: "#paper_gradient"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient-3",
    x1: 28.5,
    y1: 31.5,
    x2: 41.5,
    y2: 44.5,
    xlinkHref: "#paper_gradient"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    x2: 13,
    y2: 5.499,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 14.501,
    x2: 13,
    y2: 24,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 14.5,
    x2: 35,
    y2: 19.5,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 28.501,
    x2: 35,
    y2: 33.501,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 42.502,
    x2: 35,
    y2: 48.002,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 10,
    x2: 26.499,
    y2: 10,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 5.5,
    width: 17,
    height: 9,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#Dark_Blue_Grad_2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 5.501,
    width: 17,
    height: 9,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 19.5,
    width: 17,
    height: 9,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient-2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 33.5,
    width: 17,
    height: 9,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeBranchRevision48);
export default __webpack_public_path__ + "static/media/typeBranchRevision48.fd9c000494687879f1eff60bc43dfb97.svg";
export { ForwardRef as ReactComponent };